module.exports = __webpack_public_path__ + "static/fulfillment-centers-1b4244f46356e82cc60d888a55ac61a0.png";